import React from "react";

function PrivacyPolicy() {
  return (
    <div className="privacy-policy-page">
      <style>{`
        .privacy-policy-page {
          font-family: Arial, sans-serif;
          line-height: 1.6;
          margin: 0;
          padding: 0;
          background-color: #f4f4f4;
          min-height: 100vh;
        }

        .privacy-policy-container {
          max-width: 800px;
          margin: 20px auto;
          padding: 20px;
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        }

        .privacy-policy-container h1,
        .privacy-policy-container h2 {
          color: #333;
        }

        .privacy-policy-container h1 {
          font-size: 24px;
          margin-bottom: 10px;
        }

        .privacy-policy-container h2 {
          font-size: 20px;
          margin-top: 20px;
          border-bottom: 2px solid #ddd;
          padding-bottom: 5px;
        }

        .privacy-policy-container ul {
          list-style-type: disc;
          margin-left: 20px;
        }

        .privacy-policy-container .sub-list {
          list-style-type: circle;
          margin-left: 40px;
        }

        .privacy-policy-container p {
          margin-bottom: 20px;
        }

        .privacy-policy-footer {
          text-align: center;
          margin-top: 20px;
          padding: 10px;
          background: #eee;
          border-top: 1px solid #ddd;
        }

        @media (max-width: 600px) {
          .privacy-policy-container {
            margin: 10px;
            padding: 15px;
          }

          .privacy-policy-container h1 {
            font-size: 22px;
          }

          .privacy-policy-container h2 {
            font-size: 18px;
          }
        }
      `}</style>

      <div className="privacy-policy-container">
        <h1>Privacy Policy</h1>

        <p>
          Thank you for choosing FindMe JoinMe. We value your privacy and are
          committed to protecting your personal information. This Privacy
          Policy outlines how we collect, use, and safeguard your data when you
          use our app.
        </p>

        <h2>1. Information We Collect</h2>

        <ul>
          <li>
            <strong>Personal Information:</strong> When you create an account on
            FindMe JoinMe, we collect your name, email address, phone number,
            and any other details you provide.
          </li>

          <li>
            <strong>Location Data:</strong> To show location-based posts, we
            collect and use your device’s location data. You can control
            location services through your device settings.
          </li>

          <li>
            <strong>User-Generated Content:</strong> We collect the content you
            create and post on the app, including posts under categories such
            as:

            <ul className="sub-list">
              <li>Sports Fitness</li>
              <li>Job Holder</li>
              <li>Discounts Offers</li>
              <li>Job Seeker</li>
              <li>Job (Hiring)</li>
              <li>Give away</li>
              <li>Online Games</li>
              <li>Property Rent</li>
              <li>Health</li>
              <li>Personal</li>
              <li>Services</li>
            </ul>

            This also includes job listings, offers, comments, and messages you
            share on the platform.
          </li>

          <li>
            <strong>Usage Data:</strong> We collect data about how you interact
            with the app, including your IP address, device information, and
            app usage patterns.
          </li>
        </ul>

        <h2>2. How We Use Your Information</h2>

        <ul>
          <li>
            <strong>To Provide Services:</strong> We use your information to
            operate, maintain, and provide the features and functionality of the
            app, including showing location-based posts and facilitating
            communication between users.
          </li>

          <li>
            <strong>To Improve Our App:</strong> We use usage data to analyze
            trends, track user activity, and improve our app’s performance and
            functionality.
          </li>

          <li>
            <strong>To Communicate with You:</strong> We may use your contact
            information to send you updates, notifications, or other
            communications related to the app.
          </li>
        </ul>

        <h2>3. Sharing Your Information</h2>

        <p>
          We do not sell, trade, or otherwise transfer your personal information
          to outside parties, except as required by law or in the following
          circumstances:
        </p>

        <ul>
          <li>
            <strong>Service Providers:</strong> We may share your information
            with trusted third-party service providers who assist us in
            operating our app, conducting our business, or providing services to
            you.
          </li>

          <li>
            <strong>Legal Compliance:</strong> We may disclose your information
            when required by law or in response to valid legal requests.
          </li>
        </ul>

        <h2>4. Your Choices and Rights</h2>

        <ul>
          <li>
            <strong>Account Information:</strong> You can update, correct, or
            delete your account information at any time by accessing your
            account settings in the app.
          </li>

          <li>
            <strong>Location Data:</strong> You can manage your location
            preferences through your device settings.
          </li>

          <li>
            <strong>Communication Preferences:</strong> You can opt-out of
            receiving promotional communications from us by following the
            unsubscribe instructions in those messages.
          </li>
        </ul>

        <h2>5. Data Security</h2>

        <p>
          We implement appropriate security measures to protect your personal
          information from unauthorized access, alteration, disclosure, or
          destruction. However, no method of transmission over the internet or
          electronic storage is completely secure, so we cannot guarantee
          absolute security.
        </p>

        <h2>6. Children’s Privacy</h2>

        <p>
          FindMe JoinMe is not intended for use by children under the age of 13.
          We do not knowingly collect or solicit personal information from
          children under 13. If we become aware that we have collected personal
          information from a child under 13, we will take steps to delete that
          information as soon as possible.
        </p>

        <h2>7. Changes to This Privacy Policy</h2>

        <p>
          We may update this Privacy Policy from time to time. We will notify
          you of any changes by posting the new Privacy Policy on this page. You
          are advised to review this Privacy Policy periodically for any
          changes.
        </p>

        <footer className="privacy-policy-footer">
          <p>&copy; FindMe JoinMe. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
}

export default PrivacyPolicy;